import React from 'react';
import {
  Text,
  Badge,
  tokens,
} from '@fluentui/react-components';

interface GradeData {
  user_question: string;
  score: number;
  reasoning: string;
  timestamp: number;
  evaluator?: string;
}

interface GradeCardProps {
  grade: GradeData;
  index: number;
}

export const GradeCard: React.FC<GradeCardProps> = ({ grade, index }) => {
  return (
    <div 
      key={`grade-${grade.timestamp}-${index}`}
      style={{ 
        padding: tokens.spacingVerticalM,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: tokens.colorNeutralBackground1
      }}
    >
      <div style={{ marginBottom: tokens.spacingVerticalS }}>
        <Text weight="semibold" size={300}>
          User Question:
        </Text>
        <Text size={200} style={{ marginTop: tokens.spacingVerticalXS, display: 'block' }}>
          {grade.user_question}
        </Text>
      </div>
      
      <div style={{ marginBottom: tokens.spacingVerticalS }}>
        <Text weight="semibold" size={300}>
          Quality Score:
        </Text>
        <div style={{ display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalS, marginTop: tokens.spacingVerticalXS }}>
          <Badge 
            appearance={grade.score >= 4 ? 'filled' : grade.score >= 3 ? 'outline' : 'tint'}
            color={grade.score >= 4 ? 'success' : grade.score >= 3 ? 'warning' : 'danger'}
          >
            {grade.score}/5
          </Badge>
          <Text size={200} style={{ color: tokens.colorNeutralForeground2 }}>
            {new Date(grade.timestamp * 1000).toLocaleTimeString()}
          </Text>
        </div>
      </div>
      
      <div>
        <Text weight="semibold" size={300}>
          Evaluation Reasoning:
        </Text>
        <Text size={200} style={{ marginTop: tokens.spacingVerticalXS, display: 'block' }}>
          {grade.reasoning}
        </Text>
      </div>
    </div>
  );
};

export default GradeCard;